// IE 2026 09 27 / ODOO-… (заказ Игоря: Open task в баннере предупреждения стола): ЗАДАЧИ ПРЕДУПРЕЖДЕНИЯ СТРАНИЦЫ — чистые функции кнопки «Open task»
// жёлтого баннера (App.vue, p204). Заказ (27.09): «в жёлтом баннере предупреждения стола нужна кнопка "Open task" — открыть задачу, из-за которой висит
// предупреждение».
// Факт (бэк common_modules/workspaces.py, workspace_main.check_tasks, origin a031596ae): предупреждение ставится странице PAGES[<страница>] по строке
// doc.pages стола с `check-task` (id задачи), если последний лог этой задачи в текущей процессной модели не STATUS-end; копия строки страницы
// (PAGES[<страница>] — deepcopy строки doc.pages) несёт тот же `check-task`, поэтому id задачи уже на фронте — правка бэка не нужна. Сегмента и
// названия в строке нет: их даёт метод бэка catalog_titles (title / segment по id, любые сегменты — как у панели задач и тиража); без ответа запись
// открывается по одному id (db.get бэка ищет такой id в work.catalogs).
// Задача у страницы одна (`check-task` — одно id: бэк кладёт его ключом словаря, список он не примет); несколько — только если страница стоит в
// doc.pages стола дважды с разными задачами (бэк проверяет каждую строку) — тогда кнопка открывает их все, не больше WS_ALERT_TASKS_MAX.
// Юнит — handoff-files/ws-alert-open-task-2026-09-27/wsAlertTask.test.mjs (модуль без импортов: тест кладёт этот файл рядом с собой).

export const WS_ALERT_TASKS_MAX = 5

// id строки doc.pages — как _row_ref бэка: page / widget / workspace (сырая форма), иначе node.value
export function wsAlertTask_rowRef(r) {
    if (!r || typeof r !== 'object') return ''
    const v = r.page || r.widget || r.workspace || (r.node && typeof r.node === 'object' ? r.node.value : '') || ''
    return typeof v === 'string' || typeof v === 'number' ? String(v) : ''
}

// значение `check-task` → список id: строка; массив строк или объектов { id | value }; объект { id | value }; пустое — ничего
export function wsAlertTask_ids(v) {
    const out = []
    for (const x of (Array.isArray(v) ? v : [v])) {
        const id = (x && typeof x === 'object') ? (x.id ?? x.value) : x
        if (typeof id !== 'string' && typeof id !== 'number') continue
        const s = String(id).trim()
        if (s) out.push(s)
    }
    return out
}

// обход строк doc.pages стола вглубь (группы страниц — attrs строки-группы; attrs строки-страницы — виджеты, их id со страницей не совпадут)
function walkRows(rows, fn, depth = 0) {
    if (!Array.isArray(rows) || depth > 4) return
    for (const r of rows) {
        if (!r || typeof r !== 'object') continue
        fn(r)
        if (Array.isArray(r.attrs) && r.attrs.length) walkRows(r.attrs, fn, depth + 1)
    }
}

// задачи предупреждения страницы: `check-task` самой страницы (PAGES[страница]) и всех строк doc.pages стола этой страницы; строка с use === false
// не проверяется (как check_tasks бэка); уникальные, по порядку, не больше max
export function wsAlertTasks_of(PAGE, pageId, pagesRows, max = WS_ALERT_TASKS_MAX) {
    const seen = new Set(), out = []
    const add = (v) => { for (const id of wsAlertTask_ids(v)) { if (!seen.has(id)) { seen.add(id); out.push(id) } } }
    if (PAGE && typeof PAGE === 'object' && PAGE.use !== false) add(PAGE['check-task'])
    const pid = String(pageId || '')
    if (pid) walkRows(pagesRows, (r) => { if (r.use !== false && r['check-task'] !== undefined && wsAlertTask_rowRef(r) === pid) add(r['check-task']) })
    const cap = Number(max) > 0 ? Math.floor(Number(max)) : WS_ALERT_TASKS_MAX
    return out.slice(0, cap)
}

// задачи кнопки: id + название / сегмент из ответа catalog_titles (info[id] = { title, segment } | { miss: true } | нет — ещё не спрошено или без ответа);
// задача, записи которой нет (miss), не показывается — открывать нечего
export function wsAlertTasks_items(ids, info) {
    const out = []
    for (const id of (Array.isArray(ids) ? ids : [])) {
        const x = info && typeof info === 'object' ? info[id] : null
        if (x && x.miss) continue
        out.push({ id: String(id), title: String((x && x.title) || ''), segment: String((x && x.segment) || '') })
    }
    return out
}

// подпись задач для объяснения по Alt: названия (без названия — id) через запятую
export function wsAlertTasks_names(items) {
    return (Array.isArray(items) ? items : []).map((x) => (x && (x.title || x.id)) || '').filter(Boolean).join(', ')
}

// ответ catalog_titles → записи кэша по нужным id: найденный — { title, segment }, отсутствующий в ответе — { miss: true }; ответа нет — null
// (сбой / старый бэк / таймаут: id остаётся без названия, кнопка откроет запись по id, спросится снова)
export function wsAlertTasks_fromTitles(need, titles) {
    if (!titles || typeof titles !== 'object' || Array.isArray(titles)) return null
    const out = {}
    for (const id of (Array.isArray(need) ? need : [])) {
        const h = titles[id]
        if (h === undefined || h === null) { out[id] = { miss: true }; continue }
        out[id] = typeof h === 'string' ? { title: h, segment: '' } : { title: String(h.title || ''), segment: String(h.segment || '') }
    }
    return out
}
